import { useTranslation } from "react-i18next";

export interface UseDrybulkCargoOperationsContainerResult {
  t: ReturnType<typeof useTranslation>["t"];
  dir: "ltr" | "rtl";
}

/**
 * Container hook (DBCO-0007).
 *
 * Mirrors `useBayHireContainer`'s shape — translation plus direction — but
 * without its entry-state and role members: this skeleton takes no
 * authorisation decision (HLD § 5.3, and steering Q-F7 is open).
 */
export const useDrybulkCargoOperationsContainer = (): UseDrybulkCargoOperationsContainerResult => {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return { t, dir };
};
